
export const maxPageSize = 99999;
import axios from 'axios';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
})

export default class CustomTablePagination extends Vue {
  @Prop(Array) tableItems;
  @Prop(Number) page;
  @Prop(Array) itemsPerPageOptions;
  @Prop(Number) totalPages;
  @Prop(Number) totalRows;
  @Prop(Object) tableOptions;
  @Prop(Boolean) hideAllPagination;
  itemsPerPageValue: number = 10;
  totalCount: number = -1;
  currentPage: number = 1;
  itemsPerPageOptionsParsed: Array<object> = [];

  mounted(){
    this.currentPage = 1;
    this.syncItemsPerPageFromOptions();

    this.itemsPerPageOptionsParsed = this.itemsPerPageOptions.map((pageNumber) => {
      return {
        text: pageNumber === -1 ? 'Todas' : pageNumber,
        value: pageNumber === -1 ? maxPageSize : pageNumber
      }
    })


    if(this.hideAllPagination){
      this.itemsPerPageOptionsParsed = this.itemsPerPageOptionsParsed.filter((item) => {
        return item['text'] !== 'Todas'
      })
    }
  }

  private syncItemsPerPageFromOptions() {
    const fromTable = this.tableOptions && this.tableOptions['itemsPerPage'];
    this.itemsPerPageValue = typeof fromTable === 'number' && fromTable > 0
      ? fromTable
      : this.itemsPerPageOptions[0];
  }

  @Watch('page', { deep: true })
  observablePage(value){
    this.currentPage = value;
  }

  @Watch('tableOptions', { deep: true })
  observableTableOptions(){
    this.syncItemsPerPageFromOptions();
  }

   get totalRecords() {
          return this.tableItems.length
    }

    @Emit()
    updateTableItemsPerPage(data){
      return data.value
    }

    @Emit()
    updatePage(page){}

}
